import { Thing, WithContext } from "schema-dts"

/**
 * Returns a script element with the JSON-LD data serialized as a string.
 *
 * @param {WithContext<T>} jsonLd - The JSON-LD data to be serialized.
 * @return {JSX.Element} A script element with the JSON-LD data.
 */
export const ScriptLdJson = <T extends Thing>(jsonLd: WithContext<T>, id: string) => {
    return (
        <script
            type="application/ld+json"
            id={id}
            dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
    )
}
